var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_11-park"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256C511.8,114.7,397.3,0.2,256,0z M256,469.3 c-117.8,0-213.3-95.5-213.3-213.3S138.2,42.7,256,42.7S469.3,138.2,469.3,256C469.2,373.8,373.8,469.2,256,469.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,149.3h-74.7c-11.8,0-21.3,9.6-21.3,21.3V384h42.7v-85.3H288c41.2,0,74.7-33.4,74.7-74.7S329.2,149.3,288,149.3 L288,149.3z M288,256h-53.3v-64H288c17.7,0,32,14.3,32,32S305.7,256,288,256z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.fb34ceb974e1b040ef7e202362280324.svg";
export { ForwardRef as ReactComponent };